import React, { useState, Fragment, useRef } from "react"; // Import useRef
import { makeStyles } from "@material-ui/core/styles";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { useSelector, shallowEqual } from "react-redux"; // Make sure these are imported for useSelector/shallowEqual

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

export default function StudentFamilyBranchRow({ row, onAddLocationClick }) {
  const [open, setOpen] = useState(false); // This state isn't used in the provided snippet, but kept for completeness.
  const classes = useRowStyles();

  // Create a ref for the wrapper element around the button
  const buttonWrapperRef = useRef(null);

  // Get the current branch from Redux state
  const currentBranch = useSelector(
    (state) => state.auth.branches.currentBranch,
    shallowEqual
  );

  // Determine if the student already has the current branch associated with them.
  const hasLocation = row.branches?.some(
    (b) => b.branch_id === currentBranch?.branch_id
  );

  return (
    <Fragment>
      <TableRow className={classes.root} hover>
        <TableCell>{row.user_id}</TableCell>
        <TableCell>
          {`${row.firstname}`} {`${row.lastname}`}
        </TableCell>
        <TableCell>
          {`${row.parent_firstname}`} {`${row.parent_lastname}`}
        </TableCell>
        <TableCell>
          {row.parent_email}
          <br />
          {row.mobile}
        </TableCell>
        <TableCell>
          {/* Render the list of branches associated with the student */}
          {(row.branches || []).map((branchItem, index, arr) => (
            <Fragment key={branchItem.branch_id || index}>
              {branchItem.branch_name}
              {index < arr.length - 1 && (
                <>
                  ,<br />
                </>
              )}
            </Fragment>
          ))}
        </TableCell>
        <TableCell>
          <OverlayTrigger
            target={buttonWrapperRef.current}
            // Conditionally render the tooltip text based on hasLocation
            overlay={
              hasLocation ? (
                <Tooltip id="products-at-branch-tooltip">Already a part of this location.</Tooltip>
              ) : (
                <Tooltip id="products-add-branch-tooltip">Add New Branch</Tooltip>
              )
            }
          >
            <span ref={buttonWrapperRef} className="d-inline-block"> 
              <button
                className="btn btn-primary btn-sm"
                onClick={onAddLocationClick}
                disabled={hasLocation} 
                style={hasLocation ? { pointerEvents: 'none' } : {}}
              >
                <span>Add Location</span>
              </button>
            </span>
          </OverlayTrigger>
        </TableCell>
      </TableRow>
    </Fragment>
  );
}
